
import React from 'react';
import { Button } from '../../../components/base/Button';

export const ServicesSection: React.FC = () => {
  const services = [
    {
      icon: 'ri-logout-box-line',
      title: 'Timeshare Exit Services',
      description: 'Professional assistance to legally exit your timeshare contract. Our experts navigate complex legal processes to free you from unwanted timeshare obligations.',
      features: ['Legal Contract Review', 'Exit Strategy Planning', 'Negotiation Support', 'Documentation Handling'],
      image: 'https://public.readdy.ai/ai/img_res/a6402806fcd5c3b326dd673ff150338c.jpg'
    },
    {
      icon: 'ri-home-line',
      title: 'Resort Resales',
      description: 'Expert guidance for selling your resort property at optimal market value. We provide comprehensive market analysis and strategic selling approaches.',
      features: ['Market Valuation', 'Marketing Strategy', 'Resort ROFR', 'Transaction Support'],
      image: 'https://readdy.ai/api/search-image?query=Beautiful%20luxury%20resort%20property%20exterior%20with%20modern%20architecture%2C%20tropical%20landscaping%2C%20and%20professional%20real%20estate%20photography%2C%20bright%20and%20inviting%20atmosphere&width=400&height=300&seq=service2&orientation=landscape'
    },
    {
      icon: 'ri-file-transfer-line',
      title: 'Deed Transfer Services',
      description: 'Secure and legal property deed transfer processes. We ensure all documentation is properly handled for smooth ownership transitions.',
      features: ['Legal Documentation', 'Title Verification', 'Transfer Processing', 'Compliance Assurance'],
      image: 'https://readdy.ai/api/search-image?query=Legal%20documents%20and%20property%20deeds%20on%20professional%20desk%20with%20pen%20and%20official%20stamps%2C%20formal%20legal%20office%20setting%2C%20clean%20and%20organized%20workspace&width=400&height=300&seq=service3&orientation=landscape'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Investment Consultation',
      description: 'Strategic advice to maximize your property investment returns. Our consultants provide personalized recommendations based on market trends.',
      features: ['Portfolio Analysis', 'Investment Strategy', 'Risk Assessment', 'Performance Optimization'],
      image: 'https://readdy.ai/api/search-image?query=Financial%20consultation%20with%20charts%20and%20graphs%20on%20computer%20screen%2C%20professional%20advisor%20explaining%20investment%20strategies%2C%20modern%20office%20environment&width=400&height=300&seq=service4&orientation=landscape'
    }
  ];

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6">
            Our Expert Services
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            We provide comprehensive solutions for all your timeshare and resort property needs. 
            Our transparent approach ensures you get the best value from your investment.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
          {services.map((service, index) => (
            <div key={index} className="bg-white rounded-2xl shadow-xl overflow-hidden hover:shadow-2xl transition-shadow duration-300">
              <div className="relative h-48 overflow-hidden">
                <img 
                  src={service.image} 
                  alt={service.title}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute top-4 left-4 w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center">
                  <i className={`${service.icon} text-white text-2xl`}></i>
                </div>
              </div>
              
              <div className="p-8">
                <h3 className="text-2xl font-bold text-gray-800 mb-4">{service.title}</h3>
                <p className="text-gray-600 mb-6">{service.description}</p>
                
                <div className="space-y-2 mb-6">
                  {service.features.map((feature, featureIndex) => (
                    <div key={featureIndex} className="flex items-center space-x-3">
                      <i className="ri-check-line text-teal-600 text-lg"></i>
                      <span className="text-gray-700">{feature}</span>
                    </div>
                  ))}
                </div>
                
                <Button 
                  onClick={scrollToContact}
                  variant="outline"
                  className="w-full"
                >
                  Learn More
                </Button>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Button onClick={scrollToContact} size="lg">
            <i className="ri-phone-line mr-2"></i>
            Get Your Free Consultation Today
          </Button>
        </div>
      </div>
    </section>
  );
};
